import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_POPOVER } from '../../../../../../constants'
import { getFeatureFromCache } from '../../../../../../util/feature-cache'
import {
  LineItemFulfilmentAddCustomerViewProps,
  LineItemFulfilmentAddCustomerView as LineItemFulfilmentAddCustomerViewUnified,
} from './LineItemFulfilmentAddCustomerView'
import { LineItemFulfilmentAddCustomerViewLegacy } from './LineItemFulfilmentAddCustomerViewLegacy'

export const LineItemFulfilmentAddCustomerView: React.FC<LineItemFulfilmentAddCustomerViewProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_POPOVER
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <LineItemFulfilmentAddCustomerViewUnified {...props} />
  ) : (
    <LineItemFulfilmentAddCustomerViewLegacy {...props} />
  )
}
